export default {
  list: [
    {
      value: 'ADMIN',
      title: 'مدیر',
    },
    {
      value: 'CAFE_ADMIN',
      title: 'مدیر کافه',
    },
  ],
  values: {
    ADMIN: 'ADMIN',
    CAFE_ADMIN: 'CAFE_ADMIN',
  },
};
export const roles = {
  1: { id: 1, title: 'مدیر سیستم' },
  2: { id: 2, title: 'مدیر کافه' },
  3: { id: 3, title: 'اپراتور کافه' },
  4: { id: 4, title: 'سرپرست آرسی' },
  5: { id: 5, title: 'کارشناس ارشد' },
  6: { id: 6, title: 'کارشناس آرسی 1' },
  7: { id: 7, title: 'کارشناس آرسی 2' },
  8: { id: 8, title: 'کارشناس آرسی 3' },
};
